import React from 'react';
import { Hammer, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function StorySection() {
  return <section id="nosotros" className="py-24 bg-dark relative overflow-hidden" data-id="element-419" data-mp="gz4ut1mjlfdz">
      <div className="absolute right-0 bottom-0 w-[600px] h-[600px] bg-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-420" data-mp="c2mqu3z1dl2p"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-421" data-mp="81ue30qygy1o">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-422" data-mp="14oz1f1g9q7ps">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-423" data-mp="zqnx168qspey">
            <div className="w-16 h-16 rounded-2xl bg-dark-100 border border-white/10 flex items-center justify-center shadow-xl mb-8" data-id="element-424" data-mp="3gh4fs7qxo18x">
              <Hammer className="w-8 h-8 text-gold" data-id="element-425" data-mp="1o7oduw1bsg6q" />
            </div>

            <h2 className="text-3xl md:text-5xl font-bold text-white mb-8 leading-tight" data-id="element-426" data-mp="1o5lh7t5o3ot1">
              Construimos Esto Para Contractors Que <br data-id="element-427" data-mp="1f79tbyw6r54a" />
              <span className="text-gold" data-id="element-428" data-mp="1f7t14ms4gd4l">Merecen Más</span>
            </h2>

            <div className="space-y-6 text-lg text-gray-400" data-id="element-429" data-mp="1k5uin39wg4dy">
              <p data-id="element-430" data-mp="1k49p9gzbmrho">
                Vimos a excelentes contractors perder trabajos contra
                competidores mediocres, simplemente porque su presencia digital
                se veía amateur.
              </p>
              <p data-id="element-431" data-mp="1a9rjm6acglv8">
                Muchos pensaban que un website profesional costaba miles de
                dólares y meses de espera.{' '}
                <strong className="text-white" data-id="element-432" data-mp="10hbwyvo3r940">No tiene que ser así.</strong>
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-gradient-to-br from-dark-100 to-dark-200 p-8 md:p-12 rounded-3xl border border-white/5 shadow-2xl" data-id="element-433" data-mp="mj4717phh82c">
            <h3 className="text-2xl font-bold text-white mb-6" data-id="element-434" data-mp="2fg989cs9cxdu">
              Nuestra Misión
            </h3>
            <p className="text-xl font-medium text-gold border-l-4 border-gold pl-6 py-2 mb-8" data-id="element-435" data-mp="3c45scrmwmatt">
              Darle a los contractors la presencia online premium que merecen —
              a un precio accesible, en tiempo récord, sin complicaciones.
            </p>

            <div className="space-y-4" data-id="element-436" data-mp="2y67dll4o8cds">
              {['Demo de tu website por solo $25', 'Listo en menos de 72 horas', 'Sin mensualidades obligatorias', 'Sin contratos largos ni sorpresas'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-437" data-mp="1cmu5za3mhryx" data-mpi={i}>
                  <CheckCircle2 className="w-5 h-5 text-gold shrink-0" data-id="element-438" data-mp="1ckhjqkqu0vg2" />
                  <span className="text-white font-medium" data-id="element-439" data-mp="1hm6us0e21945">{item}</span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}